import { connect } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { ApplicationState } from '@mews-commander/types';
import { PageSize } from '@mews-commander/data-access';
import { getCurrentEnterpriseReservationPersonCount } from '@mews-commander/legacy-entities/src/selectors/reservations';
import PrintRegistrationCardsButton from '../PrintRegistrationCardsButton';
import { KeyCutterButton } from '../KeyCutterButton';
import { getPageFormatByReservationId } from './selectors';

interface OwnProps {
    reservationId: string;
    withKeyCutter?: boolean;
}
interface StateProps {
    printSize?: PageSize;
    personCount: number;
}
type ReservationSecondaryActionProps = OwnProps & StateProps;

const ReservationSecondaryActions = ({
    reservationId,
    printSize,
    personCount,
    withKeyCutter,
}: ReservationSecondaryActionProps) => (
    <>
        {withKeyCutter ? <KeyCutterButton reservationIds={[reservationId]} initKeyCount={personCount} /> : null}
        <PrintRegistrationCardsButton
            text={TextKey.RegistrationCards}
            reservationIds={[reservationId]}
            printSize={printSize}
            asIconButton
        />
    </>
);
export default connect<StateProps, {}, OwnProps, ApplicationState>((state, { reservationId }) => ({
    printSize: getPageFormatByReservationId(state, { id: reservationId }),
    personCount: getCurrentEnterpriseReservationPersonCount(state, { id: reservationId }),
}))(ReservationSecondaryActions);
